export type PickScanStatus = 'NotPicked' | 'Picked' | 'PickedAsSubstitute' | 'Missing';
export type VerifyScanStatus = 'NotVerified' | 'Verified';
export type IssueKind = 'WrongBasket' | 'OrphanStock';

export interface MedicationDetail {
  medicationId: string;
  medicationName: string;
  dosage: string;
  quantity: number;
  instruction?: string;
  pickScanStatus: PickScanStatus;
  verifyScanStatus: VerifyScanStatus;
  isSubstitute: boolean;
  pickedAt?: string;
  pickedProductId?: string;
  verifiedAt?: string;
  /** The MPS bag this line goes in; null for batches without bags. */
  bagId?: string | null;
  /** One scan picks the whole line: show fullPacks × packSize. */
  packSize?: number | null;
  fullPacks?: number | null;
  doNotSubstitute?: boolean;
  /** MPS marking such as fridge or CD, as sent. */
  marking?: string | null;
  pipCode?: string | null;
}

export interface BasketDetail {
  basketNumber: number;
  patientName: string;
  /** Second patient identifier, shown next to the name. */
  patientDob?: string | null;
  patientLocation?: string | null;
  prescriptionId: number;
  rxId: string;
  medications: MedicationDetail[];
}

export interface IssueDetail {
  id: number;
  kind: IssueKind;
  medicationId?: string;
  scannedProductId: string;
  scannedInBasket?: number;
  expectedBasket?: number;
  createdAt: string;
}

export interface BatchPickState {
  batchId: string;
  status: 'Pending' | 'Picking' | 'Picked' | 'Verifying' | 'Completed' | 'Incomplete' | 'Refused' | 'Cancelled';
  /** 'Mps' batches need the exact product and get bag labels. */
  source?: 'Mps' | 'Standard';
  missingCount: number;
  hasUnresolvedIssues: boolean;
  baskets: BasketDetail[];
  unresolvedIssues: IssueDetail[];
}

/** Treats Picked and PickedAsSubstitute as picked. Excludes Missing. */
export function isMedPicked(m: MedicationDetail): boolean {
  return m.pickScanStatus === 'Picked' || m.pickScanStatus === 'PickedAsSubstitute';
}
